import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronDown, LogOut, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const titleMap = {
  "/": "Home",
  "/people": "People",
  "/companies": "Companies",
  "/deals": "Deals",
  "/social-profiles": "Social Profiles",
  "/sequences": "Sequences",
  "/content": "Content & Social",
  "/tasks": "Agent Tasks",
  "/developers": "Buddy Terminal",
};

export default function TopBar() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [menu, setMenu] = useState(false);

  let title = titleMap[location.pathname] || "";
  if (location.pathname.startsWith("/sequences/")) title = "Sequences";
  if (location.pathname.startsWith("/companies/")) title = "Companies";

  const initials = (user?.name || "U").split(" ").map((w) => w[0]).join("").slice(0, 2);

  return (
    <header className="h-[52px] shrink-0 border-b border-[hsl(240,6%,91%)] bg-white flex items-center px-4 gap-2 relative">
      <div className="flex items-center gap-1.5 text-[14px] font-semibold">
        <span>{title}</span>
        <ChevronDown className="h-3.5 w-3.5 text-[hsl(240,4%,55%)]" />
      </div>
      <div className="ml-auto flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-1.5 rounded-md bg-[hsl(245,58%,96%)] text-[hsl(245,50%,45%)] px-2 py-[5px] text-[12px] font-medium">
          <Sparkles className="h-3.5 w-3.5" /> Hermes online
        </div>
        <button onClick={() => setMenu(!menu)} className="h-7 w-7 rounded-full bg-[hsl(245,58%,92%)] text-[hsl(245,50%,45%)] flex items-center justify-center text-[12px] font-semibold">
          {initials}
        </button>
        {menu && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setMenu(false)} />
            <div className="absolute right-4 top-[48px] z-50 w-56 rounded-lg border border-[hsl(240,6%,90%)] bg-white shadow-lg py-1.5 animate-in-up">
              <div className="px-3 py-2 border-b border-[hsl(240,6%,93%)]">
                <div className="text-[13px] font-medium">{user?.name}</div>
                <div className="text-[12px] text-[hsl(240,4%,50%)]">{user?.email}</div>
              </div>
              <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2 text-[13px] text-[hsl(240,6%,20%)] hover:bg-[hsl(240,5%,96%)]">
                <LogOut className="h-4 w-4" /> Sign out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
